<div [ngClass]="classes" class="input-component">
  <Image *ngIf="icon !== ''" type="icon" image="{{icon}}" width="24px" mobileWidth="27px"></Image>
  <form>
    <input #input (ngModelChange)="onChange($event)" [(ngModel)]="value" [type]="type" [name]="name" [autocomplete]="autocomplete" [placeholder]="placeholder" [maxlength]="maxlength" [pattern]="pattern" (input)="onInput($event)"  />
  </form>
</div>
